var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyNike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 217 77",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.937 76.969c-6.466-.256-11.756-2.018-15.892-5.29-.79-.624-2.67-2.498-3.302-3.288-1.677-2.1-2.817-4.144-3.578-6.412C-1.175 55 .029 45.841 4.61 35.79c3.923-8.606 9.976-17.141 20.536-28.962C26.7 5.087 31.334 0 31.363 0c.012 0-.24.435-.559.966-2.745 4.579-5.095 9.972-6.375 14.642-2.056 7.492-1.808 13.922.727 18.907 1.748 3.435 4.745 6.41 8.115 8.055 5.9 2.878 14.538 3.116 25.087.697.726-.168 36.715-9.68 79.975-21.138C181.593 10.669 216.994 1.3 217 1.309c.012.01-100.506 42.834-152.687 65.051-8.264 3.518-10.474 4.406-14.358 5.764-9.931 3.472-18.827 5.13-26.018 4.845Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyNike);
export default __webpack_public_path__ + "static/media/company-Nike.9df4426b37852e785bcd95746ed120b4.svg";
export { ForwardRef as ReactComponent };